import { ReactNode } from 'react'
import { BlurredBackDropSideSheet } from 'shared/components/BlurredBackDrop'
import { colors, media, zIndex } from 'shared/lib'
import styled from 'styled-components'

type ModalProps = {
  children?: ReactNode
  hasPadding?: boolean
  isOpen: boolean
  noBorder?: boolean
  widthOverride?: string
  noMinHeight?: boolean
}

export const SideSheetModal = ({
  children,
  hasPadding = true,
  isOpen,
  noBorder,
  widthOverride,
  noMinHeight,
}: ModalProps) => {
  return isOpen ? (
    <ModalBlurredBackDrop data-dismiss-on-click isActive={isOpen}>
      <Content
        widthOverride={widthOverride}
        hasPadding={hasPadding}
        noBorder={noBorder}
        noMinHeight={noMinHeight}
      >
        {children}
      </Content>
    </ModalBlurredBackDrop>
  ) : null
}

export default SideSheetModal

const ModalBlurredBackDrop = styled(BlurredBackDropSideSheet)`
  ${media.large`
    z-index: ${zIndex.justOverNav};
  `}
`
const Content = styled.div<{
  widthOverride?: string
  hasPadding?: boolean
  noBorder?: boolean
  noMinHeight?: boolean
}>`
  ${({ noBorder }) => (noBorder ? '' : `border: 1px solid ${colors.FC2_BLACK};`)}
  ${({ noMinHeight }) => (noMinHeight ? '' : 'min-height: 20%;')}
  background-color: ${colors.FC2_WHITE};
  margin: 20px;
  padding: ${({ hasPadding }) => (hasPadding ? '20px' : 0)};
  width: 100%;
  z-index: ${zIndex.sideSheetModal};

  ${({ widthOverride }) =>
    media.large`
      width: ${widthOverride ? widthOverride : '445px'};
    `}
`
